var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-2"},[_c('BaseFormLabel',[_vm._v(" Media ")]),_c('div',{staticClass:"p-4 bg-gray-100 rounded shadow-inner"},[_c('MediaList',{attrs:{"acc-product-template-id":_vm.accProductTemplateId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }